import { useRef } from 'react';

export const useStableKeys = (count: number, prefix: string) => {
  const keys = useRef<string[]>([]);
  const nextId = useRef(0);

  while (keys.current.length < count) {
    keys.current.push(`${prefix}-${nextId.current++}`);
  }

  if (keys.current.length > count) {
    keys.current = keys.current.slice(0, count);
  }

  const removeKeyAt = (index: number) => {
    keys.current = keys.current.filter((_, i) => i !== index);
  };

  return { keys: keys.current, removeKeyAt };
};
